export default __webpack_public_path__ + "static/media/miguel-lopes-32.3cb41b95.jpg";